import MainImg from "../../images/chooseUs/main.png";
import Box1 from "../../images/chooseUs/icon1.png";
import Box2 from "../../images/chooseUs/icon2.png";
import Box3 from "../../images/chooseUs/icon3.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function ChooseUs() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 overflow-hidden md:py-28 bg-gradient-to-b from-slate-50 to-white">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#f5272b] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 rounded-full w-96 h-96 bg-slate-800 blur-3xl"></div>
      </div>

      <div className="container relative z-10 px-4 mx-auto md:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="grid items-center grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
            {/* Image Section */}
            <div className="relative order-2 lg:order-1">
              <div className="absolute inset-0 bg-gradient-to-br from-[#f5272b]/10 to-transparent rounded-3xl blur-2xl"></div>
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-slate-800/5 to-transparent rounded-3xl"></div>
                <img
                  className="relative w-full h-auto object-cover rounded-3xl shadow-2xl hover:scale-[1.02] transition-transform duration-500"
                  src={MainImg}
                  alt="car_img"
                />
              </div>
            </div>

            {/* Content Section */}
            <div className="order-1 space-y-8 lg:order-2">
              {/* Header */}
              <div className="space-y-4">
                <h4 className="text-[#f5272b] font-semibold text-lg md:text-xl tracking-wide uppercase">
                  {t("why_choose_use")}
                </h4>
                <h2 className="text-4xl font-bold leading-tight md:text-5xl lg:text-6xl text-slate-900">
                  {t("best_valued")}
                </h2>
                <p className="max-w-xl text-lg leading-relaxed md:text-xl text-slate-600">{t("discover_the_best")}</p>
                <Link
                  to="/why-choose-us"
                  className="inline-flex items-center gap-3 px-8 py-4 bg-[#f5272b] hover:bg-red-700 text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 group"
                >
                  {t("find_details")}
                  <i className="text-lg transition-transform fa-solid fa-angle-right group-hover:translate-x-1"></i>
                </Link>
              </div>

              {/* Feature Boxes */}
              <div className="grid grid-cols-1 gap-6 pt-4">
                {/* Box 1 */}
                <div className="p-6 transition-all duration-300 bg-white border shadow-lg group hover:bg-slate-50 rounded-2xl hover:shadow-xl border-slate-100">
                  <div className="flex items-start gap-5">
                    <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-[#f5272b] to-red-600 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <img src={Box1} alt="cross-city" className="object-contain w-9 h-9" />
                    </div>
                    <div className="flex-1 space-y-2">
                      <h4 className="text-xl font-bold text-slate-900">{t("cross_city")}</h4>
                      <p className="leading-relaxed text-slate-600">{t("take_your_driving")}</p>
                    </div>
                  </div>
                </div>

                {/* Box 2 */}
                <div className="p-6 transition-all duration-300 bg-white border shadow-lg group hover:bg-slate-50 rounded-2xl hover:shadow-xl border-slate-100">
                  <div className="flex items-start gap-5">
                    <div className="flex items-center justify-center flex-shrink-0 w-16 h-16 transition-transform duration-300 shadow-lg bg-gradient-to-br from-slate-800 to-slate-900 rounded-xl group-hover:scale-110">
                      <img src={Box2} alt="all-inclusive" className="object-contain w-9 h-9" />
                    </div>
                    <div className="flex-1 space-y-2">
                      <h4 className="text-xl font-bold text-slate-900">{t("all_inclusive")}</h4>
                      <p className="leading-relaxed text-slate-600">{t("get_everything")}</p>
                    </div>
                  </div>
                </div>

                {/* Box 3 */}
                <div className="p-6 transition-all duration-300 bg-white border shadow-lg group hover:bg-slate-50 rounded-2xl hover:shadow-xl border-slate-100">
                  <div className="flex items-start gap-5">
                    <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-[#f5272b] to-red-600 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <img src={Box3} alt="no-hidden" className="object-contain w-9 h-9" />
                    </div>
                    <div className="flex-1 space-y-2">
                      <h4 className="text-xl font-bold text-slate-900">{t("no_hidden")}</h4>
                      <p className="leading-relaxed text-slate-600">{t("enjoy_peace")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChooseUs;
